export const GET_CASES_PENDING = '[CASES][GET] get Cases pending';
export const GET_CASES_SUCCESS = '[CASES][GET] get Cases success';
export const GET_NEW_CASES_SUCCESS = '[CASES][GET] get New Cases success';

export const SET_CASES_PARAMS_SUCCESS = '[CASES][SET] set Cases params success';
export const SET_POPULATE_PAYLOAD_SUCCESS = '[CASES] set Populate Payload success';

export const GET_CASES_FAILURE = '[CASES][GET] get Cases failure';
export const GET_CASE_DETAIL_PENDING = '[CASES][DETAIL] get case details pending';
export const GET_CASE_DETAILS_SUCCESS = '[CASES][DETAIL] get case details success';
export const CASES_GET_LINKED_CASE_SHOWFLAG = '[CASES][DETAIL] get case linked showflag';
export const GET_CASE_DETAIL_FAILURE = '[CASES][DETAIL] get case details failure';
export const GET_CASE_DETAIL_SUCCESS = '[CASES][DETAIL] get case detail success';
export const GET_FIELD_PENDING = '[CASES][FIELD] get field pending';
export const GET_FIELD_SUCCESS = '[CASES][FIELD] get field success';
export const GET_FIELD_FAILURE = '[CASES][FIELD] get field failure';
export const GET_CASE_IDS_PENDING = '[CASES][GET] get Case Ids pending';
export const GET_CASE_IDS_SUCCESS = '[CASES][GET] get Case Ids success';
export const GET_CASE_IDS_FAILURE = '[CASES][GET] get Case Ids failure';
export const GET_CASES_MESSAGES_COUNTS_PENDING = '[CASES][GET] get cases messages count pending';
export const GET_CASES_MESSAGES_COUNTS_SUCCESS = '[CASES][GET] get cases messages count success';
export const GET_CASES_MESSAGES_COUNTS_FAILURE = '[CASES][GET] get cases messages count failure';
export const GET_CASE_CONSENTS_SUCCESS = '[CONSENTS][GET] get consents success';
export const GET_ENGAGEMENT_FREQUENCY_LIST = '[GET][ENGAGEMENT][FREQUENCY_LIST] get engagenment frequency list';
export const GET_EY_STATUS_SUCCESS = '[EYSTATUS][GET] get eystatus success';
export const GET_EY_STATUS_SUCCESS_API_TABLE = '[eyStatusApiResult][GET] get eystatus API success';
export const GET_CASE_STATUS_SUCCESS = '[CASES][GET] get case status message list';
export const GET_ADDITIONAL_INFO_SUCCESS = '[CASES][GET] get additional information message detail';
export const UPDATE_RELATED_RETURN_STORE = '[CASES][UPDATE] update related return store value';

// modal
export const SHOW_FILTER_MODAL = '[CASES][FILTERS] toggle Modal';
export const HYDRATE_CASES = '[CASES][DOCUMENTS] hydrate case documents';
export const HYDRATE_CASES_FILTERS = '[CASES][FILTERS] hydrate filters';
export const APPLY_CASES_FILTERS = '[CASES][FILTERS] apply filters';
export const APPLY_CASES_FILTERS_SUCCESS = '[CASES][FILTERS] apply filters success';
export const APPLY_CASES_FILTERS_FAILURE = '[CASES][FILTERS] apply filters failure';
export const GO_TO_DETAILS = '[CASES][LINK] redirect to case details';
export const GET_FILTERS_SUCCESS = '[CASES][FILTERS] get case filters';
export const STORE_CASE_DETAILS = '[CASES][DETAIL] store case details.';
export const STORE_CASE_MANAGER_ID = '[CASES][DETAIL] store case manager id.';
export const STORE_CASE_MESSAGES_COUNT = '[CASES][DETAIL] store case messages count';
export const GET_IMMIGRATION_PATHWAY_SUCCESS = '[CASES][IMMIGRATION] get the immigration list success';

export const SHOW_NOTIFICATION_SUCCESS = '[CASES][SHOW] show notification success';
export const HIDE_NOTIFICATION_SUCCESS = '[CASES][HIDE] hide notification success';
export const RESET_CASE_MANAGER_ID = '[CASES][DETAIL] clear case manager id';
export const GET_CASE_PHASES_SUCCESS = '[CASES][DETAIL] get case phases';

export const GET_PRODUCTLIST_BY_ORGYEAR_PENDING = '[CASES][DETAIL] Get product list by organizer type and year pending';
export const GET_PRODUCTLIST_BY_ORGYEAR_SUCCESS = '[CASES][DETAIL] Get product list by organizer type and year success';
export const GET_PRODUCTLIST_BY_ORGYEAR_FAILURE = '[CASES][DETAIL] Get product list by organizer type and year failure';

export const CREATE_TAXCHAT_QUESTIONNAIRE_PENDING = '[CASES][DETAIL] Create tax chat questionnaire pending';
export const CREATE_TAXCHAT_QUESTIONNAIRE_SUCCESS = '[CASES][DETAIL] Create tax chat questionnaire success';
export const CREATE_TAXCHAT_QUESTIONNAIRE_FAILURE = '[CASES][DETAIL] Create tax chat questionnaire failure';

export const SHOW_CREATE_QUEST_NOTIFICATION_SUCCESS = '[CASES][DETAIL] Show create questionnaire notification success';
export const HIDE_CREATE_QUEST_NOTIFICATION_SUCCESS = '[CASES][DETAIL] Hide create questionnaire notification success';

//Case Filter
export const CLEAR_FILTER = 'clear filter';
export const ON_CHANGE = 'on change';
export const ON_CHANGE_DATE = 'on change date';

//Experian
export const GET_EXPERIAN_RESULTS_SUCCESS = '[CASES][EXPERIAN] get exerperian results success';
export const GET_EXPERIAN_RESULTS_FAILURE = '[CASES][EXPERIAN] get exerperian results failure';

export const GET_EXPERIAN_BGCHECK_RESULTS_SUCCESS = '[CASES][EXPERIAN] get exerperian bgcheck results success';
export const GET_EXPERIAN_BGCHECK_RESULTS_FAILURE = '[CASES][EXPERIAN] get exerperian bgcheck results failure';

export const GET_EXPERIAN_PDF_SUCCESS = '[CASES][EXPERIAN] get exerperian PDF success';
export const GET_EXPERIAN_PDF_FAILURE = '[CASES][EXPERIAN] get exerperian PDF failure';

export const GET_EXPERIAN_TEST_EXPORT_TO_PDF_SUCCESS = '[CASES][EXPERIAN] get exerperian test export to PDF success';
export const GET_EXPERIAN_TEST_EXPORT_TO_PDF_FAILURE = '[CASES][EXPERIAN] get exerperian test export to PDF failure';

export const OPEN_DOCUMENTS_SUCCESS = '[DOCUMENTS][POST] open Documents success';
export const EY_FILE_BUTTON = 'INTIATE EFILE success';
export const GET_EXTENSION_DETAILS_CONTACTS = 'GET_EXTENSION_DETAILS_CONTACTS';
export const GET_PRIMARYCASE_CONTACTS = 'GET_PRIMARYCONTACTS';
export const GET_SECONDARYCASE_CONTACTS = 'GET_SECONDARYCONTACTS';
export const GET_TERITARY_CONTACTS = 'GET_TERITARYCONTACTS';
export const GET_COE_MEMBER_CONTACTS = 'GET_COEMEMBERCONTACTS';
export const GET_DELEGATECASE_CONTACTS = 'GET_DELEGATECONTACTS';
export const GET_EY_STATUS_COUNTRY = 'GET COUNTRY STATUS';
export const EXPERIAN_CHAT_MESSAGE = 'EXPERIAN CHAT MESSAGE';
export const FAVORITE_CHECKBOX = 'FAVORITE_CHECKBOX';
export const GET_LOGS_LIST_SUCCESS = '[LOGS] [GET] [SUCCESS]';
export const GET_MISSING_INFO = "Get Missing Information";
export const GET_MISSING_INFO_FAILURE = "Get Missing Information Failure";



// WEBPACK FOOTER //
// ./src/ui/features/Cases/state/casesTypes.js